export default {"src":"/_next/static/media/COIN.ad1fb338.svg","height":18,"width":18};